'use client'

import { useTranslation } from '@/hooks/client/use-translation'

import { PartnershipFields } from './partnership-fields'
import { usePartnershipForm } from './use-partnership-form'

export const PartnershipForm = () => {
  const { t } = useTranslation()
  const { state, handleSubmit } = usePartnershipForm()
  const isSubmitting = state.status === 'submitting'

  return (
    <div className="rounded-2xl bg-white p-6 sm:p-8 print:hidden">
      <h3 id="partnership-form-title" className="text-navy mb-6 text-xl font-semibold">
        {t('mediaKit.contact.formTitle', 'Contact Tony')}
      </h3>
      <div aria-live="polite">
        {state.status === 'success' ? (
          <p className="text-navy text-base leading-relaxed" role="status">
            {t(
              'mediaKit.contact.formSuccess',
              'Thanks for getting in touch. Tony will follow up about your partnership.'
            )}
          </p>
        ) : (
          <form onSubmit={handleSubmit} method="post" aria-labelledby="partnership-form-title" aria-busy={isSubmitting}>
            <PartnershipFields disabled={isSubmitting} />
            {state.status === 'error' && (
              <p role="alert" className="text-error mt-5 text-sm leading-relaxed">
                {state.message}
              </p>
            )}
            <button
              type="submit"
              data-tracking="ignore"
              disabled={isSubmitting}
              className="bg-navy text-cream hover:bg-navy-90 focus-visible:outline-navy mt-6 w-full cursor-pointer rounded-xl px-5 py-3.5 text-[0.92rem] font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-4 disabled:cursor-wait disabled:opacity-70"
            >
              {isSubmitting
                ? t('contact.submitting', 'Sending your message…')
                : t('mediaKit.contact.formSubmit', 'Send partnership enquiry')}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
